import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import LessonActions from "src/components/NewComponents/menuActions/LessonActions";
import ExamActions from "src/components/NewComponents/Views/Actions/ExamActions";
import { useGetLesson } from "src/hooks/useCourses";
import EditIcon from "src/images/Icons/newIcons/exam/more/edit.svg";

interface WaitingActionsProps {
	lesson: any;
	toggleNote: () => void;
}

export const WaitingActions = ({ lesson, toggleNote }: WaitingActionsProps) => {
	const { t } = useTranslation();
	const history = useHistory();
	const { mutateAsync: getLesson, isPending: isLoading } = useGetLesson();

	const onPrimary = async (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		const id = await (getLesson as any)({
			courseId: lesson.courseId,
			lessonId: lesson.id,
		});
		return history.push(generatePath(routing.paths.exam, { id }));
	};

	return (
		<ExamActions
			row={{ status: lesson?.status }}
			isLoading={isLoading}
			onPrimary={onPrimary}
			primaryText={t("commands.start")}
			menuActions={
				<LessonActions
					row={{}}
					additionalActions={[
						{
							title: t("menuActions.lessons.addNote"),
							onClick: toggleNote,
							Icon: <EditIcon className="icon-small" />,
						},
					]}
				/>
			}
		/>
	);
};
